/**
 * Created by razial on 21.09.2026.
 */

Mission.TYPE_LANTERN = 9;

Forces.LANTERN = {
    id: 20,
    text: "LanternWindow.force"
};

Reward.register("lantern", {
    flyingAnimation: Reward.CUSTOM_COLLECT,

    parse: function (value, options) {
        return [new Reward(
            "lantern",
            value,
            options
        )];
    },

    getCustomRewardIcon: function () {
        return bundles.lantern.jsons.lantern_reward_json;
    },

    getCustomRewardIconAnimation: function () {
        const lantern = Lantern.Get();
        const streak = lantern ? lantern.streak : 1;

        return {
            before: `idle_${String(streak - 1)}`,
            during: `stage_${String(streak)}`,
            after: `idle_${String(streak)}`
        };
    },

    getCustomRewardOpenEffect: function () {
        return "mission.lantern.win";
    },

    getCustomRewardProgress: function () {
        return bundles.lantern.jsons.lantern_progress_json;
    },

    getCustomRewardProgressAnimation: function (options) {
        return RewardTypes.lantern.getCustomRewardIconAnimation(options);
    },

    receive: function () {
        const lantern = Lantern.Get();
        if (lantern) {
            lantern.incStreak();
        }

        return function () {};
    }
});

Mission.REGISTRATIONS.set(Mission.TYPE_LANTERN, () => ({
    ...BaseMissionData(),
    available: cleverapps.config.availables.LANTERN_MISSION,
    name: "Lantern",
    view: LanternWindow,
    duration: "2 day",
    semaphore: Mission.SEMAPHORE_CUSTOM_LANTERN,
    startWindow: LanternWindow,
    sideBarJson: bundles.sidebar.jsons.lantern_icon_json,
    iconForce: Forces.LANTERN,
    logic: LanternMissionLogic,
    prize: undefined
}));
